/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const AddEmoji = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <g fill="none" fillRule="evenodd">
        <rect fill="#3d3d36" height="1" rx=".5" width="7" y="3" />
        <rect fill="#3d3d36" height="7" rx=".5" width="1" x="3" />
        <path
          d="m9 16c3.8659932 0 7-3.1340068 7-7 0-3.86599325-3.1340068-7-7-7-3.86599325 0-7 3.13400675-7 7"
          fillRule="nonzero"
          stroke="#3d3d36"
          strokeLinecap="round"
          transform="matrix(0 1 -1 0 18 0)"
        />
        <path
          d="m7.5 14.5c1.65685425 0 3-1.3431458 3-3 0-1.65685425-1.34314575-3-3-3"
          fillRule="nonzero"
          stroke="#3d3d36"
          strokeLinecap="round"
          transform="matrix(0 1 -1 0 20.5 2.5)"
        />
        <g fill="#3d3d36">
          <circle cx="6.25" cy="7.25" r="1" />
          <circle cx="11.75" cy="7.25" r="1" />
        </g>
      </g>
    </BaseSvgIcon>
  )
}

export default AddEmoji
